// O app pergunta ao banco se a assinatura da conta esta valida (migration 0041,
// funcao public.minha_assinatura). A PAREDE de verdade e o banco: conta sem
// acesso enxerga zero linhas em qualquer tabela. Esta tela e so a explicacao
// legivel para quem bateu nela.
//
// ⚠ Na duvida, LIBERA. Sem sinal, com a rede lenta ou com o banco fora, a
// pergunta falha, e o representante na rua nao pode perder o trabalho por isso:
// quem esta de fato sem assinatura continua sem ver dado nenhum, porque a
// parede e o banco.

export interface LinhaDeAssinatura {
  status: string
  acesso_ate: string | null
  ativo: boolean
}

export type Acesso =
  | { situacao: 'liberado' }
  | { situacao: 'inativo'; status: string; acessoAte: string | null }

export function decidirAcesso(
  resposta: { data: LinhaDeAssinatura[] | null; error: unknown } | null,
): Acesso {
  if (!resposta || resposta.error) return { situacao: 'liberado' }
  const linha = resposta.data?.[0]
  if (!linha) return { situacao: 'liberado' }
  if (linha.ativo) return { situacao: 'liberado' }
  return { situacao: 'inativo', status: linha.status, acessoAte: linha.acesso_ate }
}

/** O texto da tela de bloqueio. Sem exclamacao, sem culpa. */
export function textoDoBloqueio(status: string): { titulo: string; corpo: string } {
  if (status === 'cancelado') {
    return {
      titulo: 'Sua assinatura terminou',
      corpo:
        'O período pago da sua assinatura acabou, e o acesso ao CRM foi encerrado. Os seus dados ficam guardados. Para voltar a usar, fale com a gente.',
    }
  }
  return {
    titulo: 'Sua assinatura está inativa',
    corpo:
      'O acesso ao CRM está suspenso por causa da assinatura. Os seus dados ficam guardados. Para entender o motivo e voltar a usar, fale com a gente.',
  }
}

/** Cadastro fechado no Supabase: troca o erro tecnico por uma explicacao. */
export function mensagemDeCadastroFechado(error: { code?: string; message?: string }): string | null {
  const fechado =
    error.code === 'signup_disabled' || (error.message ?? '').includes('Signups not allowed')
  if (!fechado) return null
  return 'O acesso ao CRM é liberado pela assinatura. Depois da compra, você recebe um e-mail para criar a sua senha.'
}
